(function (window, document, jQuery, undefined) {

    // Adds 100px on top of scrollto target to have it not exactly on top.
    // It looks better if 100px are added.
    window.addEventListener("hashchange", function () {
        window.scrollTo(
            window.scrollX,
            window.scrollY - 100);
    });

})(window, document, jQuery);